import io from "socket.io-client";
import api from "../services/api";


class SocketWorker {
  constructor(companyId , userId) {
    const sessionToken = api.defaults.headers.Authorization

    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.token = sessionToken
      this.socket = null;
      this.configureSocket();
      this.eventListeners = {}; // Armazena os ouvintes de eventos registrados
      SocketWorker.instance = this;

    }

    return SocketWorker.instance;
  }

  configureSocket() {
    const socketUrl = `${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}`;

    this.socket = io(socketUrl, {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      query: { userId: this.userId, token: this.token }
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("disconnect", () => {
      console.log("Desconectado do servidor Socket.IO");
      this.reconnectAfterDelay();
    });

    this.socket.on("connect_error", (error) => {
      console.error("Erro de conexão Socket.IO:", error.message);
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {
    this.connect();

    // Verificar se socket foi criado com sucesso
    if (!this.socket) {
      console.error('SocketWorker: Socket não foi criado. Verificar companyId e configurações.');
      return false;
    }

    try {
      this.socket.on(event, callback);

      // Armazena o ouvinte no objeto de ouvintes
      if (!this.eventListeners[event]) {
        this.eventListeners[event] = [];
      }
      this.eventListeners[event].push(callback);
      return true;
    } catch (error) {
      console.error('Erro ao adicionar listener:', error);
      return false;
    }
  }

  // Emite um evento
  emit(event, data) {
    this.connect();

    // Verificar se socket foi criado com sucesso
    if (!this.socket) {
      console.error('SocketWorker: Socket não foi criado. Não é possível emitir evento:', event);
      return false;
    }

    try {
      this.socket.emit(event, data);
      return true;
    } catch (error) {
      console.error('Erro ao emitir evento:', error);
      return false;
    }
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    // console.log(event, callback)
    if (!this.socket) {
      console.warn('SocketWorker: Socket não existe. Não é possível remover listener:', event);
      return false;
    }

    try {
      if (this.eventListeners[event]) {
        // console.log("Desconectando do servidor Socket.IO:", event, callback);
        if (callback) {
          // Desconecta um ouvinte específico
          this.socket.off(event, callback);
          this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
        } else {
          // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

          // Desconecta todos os ouvintes do evento
          this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
          delete this.eventListeners[event];
        }
        // console.log("EVENTOS DO SOCKET:", this.eventListeners);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Erro ao remover listener:', error);
      return false;
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      SocketWorker.instance = null;
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
    return this.socket !== null;
  }

  // Verifica se o socket está conectado
  isConnected() {
    return this.socket && this.socket.connected;
  }

  // Obter status da conexão
  getConnectionStatus() {
    if (!this.socket) return 'disconnected';
    return this.socket.connected ? 'connected' : 'disconnected';
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;